import axios from "axios";
import * as actionTypes from "../actions/actionTypes";

export const initSendPostAsDraft = () => {
  return {
    type: actionTypes.INIT_SEND_POST_AS_DRAFT,
    sendingPostToDraft: true,
    draftPost: null,
    draftPostId: null,
  };
};

export const successSendPostAsDraft = (data) => {
  return {
    type: actionTypes.SUCCESS_SEND_POST_AS_DRAFT,
    sendingPostToDraft: false,
    draftPostId: data.data.id,
    draftPost: data,
  };
};

export const failSendPostAsDraft = (error) => {
  return {
    type: actionTypes.FAIL_SEND_POST_AS_DRAFT,
    sendingPostToDraft: false,
    error: error,
  };
};

export const sendPostAsDraft = (vehicleType, data, mediaData, vidMedia) => {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
    },
  };
  const configMedia = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("idToken"),
      "Content-Type": "multipart/form-data",
    },
  };
  const postData = { ...data };
  const mediaLen = mediaData.media.length;
  let uploadedImgCounter = 0;
  if (!vidMedia) {
    return (dispatch) => {
      dispatch(initSendPostAsDraft());
      axios
        .post(`${vehicleType}/lists`, postData, config)
        .then((response) => {
          const postId = response.data.data.id;
          localStorage.setItem("draftId", postId);
          dispatch(successSendPostAsDraft(response.data));
          // mediaData.media.forEach((img, i) => {
          //     let formData = new FormData();
          //     formData.append(`media[${i}][name]`, img.name)
          //     formData.append(`media[${i}][content]`, img.content)
          //     axios.post(`${vehicleType}/lists/${postId}`, formData, configMedia)
          //         .then(res => {
          //             console.log(res, i, mediaLen, uploadedImgCounter);
          //             uploadedImgCounter++;
          //             console.log(uploadedImgCounter)
          //             if (uploadedImgCounter === mediaLen) {
          //                 dispatch(successSendPostAsDraft(response.data));
          //                 // dispatch(getPreviewPost(postId));
          //             }
          //         })
          // });
          // dispatch(successSendPostAsDraft(response.data)); this IS THE ONE
          // dispatch(getPreviewPost(postId));
        })
        .catch((error) => {
          dispatch(failSendPostAsDraft(error.message));
        });
    };
  } else if (vidMedia) {
    let postId = null;
    return (dispatch) => {
      dispatch(initSendPostAsDraft());
      axios
        .post(`${vehicleType}/lists`, postData, config)
        .then((response) => {
          // const postId = response.data.data.id;
          postId = response.data.data.id;
          localStorage.setItem("draftId", postId);
          let vidFormData = new FormData();
          vidFormData.append(`media[${mediaLen + 1}][name]`, vidMedia.name);
          vidFormData.append(
            `media[${mediaLen + 1}][content]`,
            vidMedia.content
          );
          vidFormData.append(`media[${mediaLen + 1}][type]`, "mp4");
          axios
            .post(`${vehicleType}/lists/${postId}`, vidFormData, configMedia)
            .then((response) => {
              dispatch(successSendPostAsDraft(response.data));
              // mediaData.media.forEach((img, i) => {
              //     let formData = new FormData();
              //     formData.append(`media[${i}][name]`, img.name)
              //     formData.append(`media[${i}][content]`, img.content)
              //     axios.post(`${vehicleType}/lists/${postId}`, formData, configMedia)
              //         .then(res => {
              //             console.log(res, i, mediaLen, uploadedImgCounter);
              //             uploadedImgCounter++;
              //             console.log(uploadedImgCounter)
              //             if (uploadedImgCounter === mediaLen) {
              //                 dispatch(successSendPostAsDraft(response.data));
              //                 // dispatch(getPreviewPost(postId));
              //             }
              //         })
              // });
            })
            .catch((error) => {
              mediaData.media.forEach((img, i) => {
                let formData = new FormData();
                formData.append(`media[${i}][name]`, img.name);
                formData.append(`media[${i}][content]`, img.content);
                axios
                  .post(`${vehicleType}/lists/${postId}`, formData, configMedia)
                  .then((res) => {
                    uploadedImgCounter++;
                    if (uploadedImgCounter === mediaLen) {
                      dispatch(successSendPostAsDraft(response.data));
                      // dispatch(getPreviewPost(postId));
                    }
                  });
              });
            });
        })
        .catch((error) => {
          dispatch(failSendPostAsDraft(error.message));
        });
    };
  }
};
